<div class="container-fluid">
  <div class="mct-flex mct-col mct-justify-center mct-items-start mb-10 mct-gap-5">
    <h3 class="m-0">
      {{ 'events.settings.sponsors.title' | translate | titlecase }}
      <a href="#" (click)="$event.preventDefault()" class="ml-2">
        <i class="pi pi-question-circle wc-help-icon" [title]="'events.settings.sponsors.sponsors-title-help' | translate"></i>
      </a>
    </h3>
    <button
      pButton
      class="atlas-btn atlas-btn-secondary"
      [disabled]="userAccessLevel < 2"
      icon="pi pi-plus"
      [label]="'events.settings.sponsors.add-button-label' | translate | titlecase"
      (click)="newSponsor()"
    ></button>
  </div>

  <div [hidden]="!loadingSponsors" class="text-center py-5">
    <wl-busy [show]="loadingSponsors"></wl-busy>
    <p class="mt-2 text-muted">{{ 'common.loading' | translate | titlecase }}...</p>
  </div>

  <div class="card shadow-none border bg-light p-5 text-center" [hidden]="loadingSponsors || sponsors?.length">
    <i class="pi pi-users text-muted mb-3" style="font-size: 3rem"></i>
    <p class="lead m-0 text-muted">{{ 'events.settings.sponsors.no-sponsors' | translate | titlecase }}</p>
  </div>

  <div [hidden]="loadingSponsors || !sponsors?.length">
    <p class="small text-muted mb-3">
      <i class="pi pi-info-circle mr-1"></i> {{ 'events.settings.sponsors.click-name-to-drag' | translate }}
    </p>

    <div class="mb-10">
      <table class="table mb-0">
        <thead class="bg-light">
          <tr>
            <th style="width: 50px"></th>
            <th style="width: 80px"></th>
            <th>{{ 'events.settings.sponsors.name-column-header' | translate | titlecase }}</th>
            <th class="text-right">{{ 'common.actions' | translate | titlecase }}</th>
          </tr>
        </thead>
        <tbody cdkDropList (cdkDropListDropped)="sorted($event)">
          <tr *ngFor="let item of sponsors; let i = index" cdkDrag class="wc-movable-row">
            <td class="text-muted cursor-move" cdkDragHandle>
              <i class="pi pi-bars"></i>
            </td>
            <td>
              <div class="sponsor-logo-preview-sm">
                <img *ngIf="item.SponsorLogoUrl" [src]="getSponsorLogoSrc(item.SponsorLogoUrl)" class="img-thumbnail shadow-xs" />
                <i *ngIf="!item.SponsorLogoUrl" class="pi pi-image text-muted"></i>
              </div>
            </td>
            <td class="align-middle">
              <span class="font-weight-bold">{{ item.SponsorName }}</span>
              <div class="small text-muted" *ngIf="item.SponsorWebsite">{{ item.SponsorWebsite }}</div>
            </td>
            <td class="text-right align-middle">
              <button
                pButton
                type="button"
                class="atlas-btn atlas-btn-default"
                icon="pi pi-pencil"
                [label]="'common.edit' | translate | titlecase"
                (click)="editSponsor(item.SponserId)"
              ></button>
              <button
                pButton
                type="button"
                class="atlas-btn atlas-btn-danger"
                icon="pi pi-trash"
                [label]="'common.delete' | translate | titlecase"
                (click)="confirmDeleteSponsor(item.SponserId)"
              ></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <app-back-to-top></app-back-to-top>
</div>

<p-dialog
  #eventSponsorsModal
  modal="true"
  [(visible)]="showEditModal"
  [closable]="true"
  styleClass="atlas-dialog-l"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    <h4 class="modal-title">
      <i class="pi pi-star mr-2"></i>
      {{ 'events.settings.sponsors.title' | translate | titlecase }}
    </h4>
  </ng-template>

  <div class="container-fluid pt-2">
    <div *ngIf="loadingSponsor.busy" class="text-center py-5">
      <wl-busy [show]="loadingSponsor.busy"></wl-busy>
    </div>

    <div class="alert alert-danger" *ngIf="loadingSponsor.message && !loadingSponsor.success">
      {{ loadingSponsor.message }}
    </div>

    <div class="form-horizontal" *ngIf="!loadingSponsor.busy">
      <div class="form-group">
        <label class="col-sm-3 control-label">{{ 'events.settings.sponsors.profile-lookup-label' | translate | titlecase }}</label>
        <div class="col-sm-9">
          <wl-profile-selector
            required
            [(ngModel)]="selectedSponsor.ProfileId"
            [loadMinProfile]="false"
            (onProfileChanged)="sponsorProfileChanged($event)"
          >
          </wl-profile-selector>
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-3 control-label">{{ 'events.settings.sponsors.image-lookup-label' | translate | titlecase }}</label>
        <div class="col-sm-9 mct-flex mct-row mct-gap-15">
          <div class="">
            <wl-image-lookup name="image" [(ngModel)]="selectedSponsor.SponsorLogoUrl"></wl-image-lookup>
            <p class="small text-muted mt-1">Recommended size: 300x200px (PNG or JPG)</p>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-3 control-label">{{ 'events.settings.sponsors.name-label' | translate | titlecase }}</label>
        <div class="col-sm-9">
          <input class="form-control" type="text" [(ngModel)]="selectedSponsor.SponsorName" placeholder="Brand Name" />
        </div>
        <div class="col-sm-9 col-sm-offset-3">
          <p-checkbox binary="true" [(ngModel)]="selectedSponsor.HideSponsorOrgName"></p-checkbox>
          <label class="control-label">{{ 'events.settings.sponsors.hide-sponsor-org-name-label' | translate | titlecase }}</label>
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-3 control-label">{{ 'events.settings.sponsors.message-label' | translate | titlecase }}</label>
        <div class="col-sm-9">
          <textarea
            class="form-control"
            rows="2"
            [(ngModel)]="selectedSponsor.SponsorMessage"
            placeholder="Short message or tagline..."
          ></textarea>
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-3 control-label">{{ 'events.settings.sponsors.website-label' | translate | titlecase }}</label>
        <div class="col-sm-9">
          <div class="input-group">
            <span class="input-group-addon"><i class="pi pi-external-link"></i></span>
            <input class="form-control" type="url" [(ngModel)]="selectedSponsor.SponsorWebsite" placeholder="https://" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="alert alert-danger text-left" *ngIf="savingError">
      {{ savingError }}
    </div>
    <div class="mct-flex mct-row mct-justify-end mct-items-center mct-gap-10">
      <wl-busy [show]="saving"></wl-busy>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-primary"
        (click)="saveSponsors()"
        [disabled]="saving"
        icon="pi pi-save"
        [label]="(saving ? 'common.saving' : 'common.save') | translate | titlecase"
      ></button>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-secondary"
        (click)="showEditModal = false"
        [disabled]="saving"
        icon="pi pi-ban"
        [label]="'common.cancel' | translate | titlecase"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  #confirmDeleteEventSponsorsModal
  modal="true"
  [(visible)]="showDeleteModal"
  [closable]="false"
  styleClass="atlas-dialog-m"
  [focusOnShow]="false"
>
  <div class="text-center p-4">
    <i class="pi pi-exclamation-triangle text-danger" style="font-size: 3rem"></i>
    <h5 class="mt-3">{{ 'events.settings.sponsors.delete-confirm' | translate }}</h5>
  </div>

  <ng-template pTemplate="footer">
    <div class="alert alert-danger text-left" *ngIf="deleteError">
      {{ deleteError }}
    </div>
    <div class="mct-flex mct-row mct-gap-10">
      <wl-busy [show]="deleting"></wl-busy>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-danger"
        (click)="deleteSponsor()"
        [disabled]="deleting"
        icon="pi pi-trash"
        [label]="(deleting ? 'common.deleting' : 'common.delete') | translate | titlecase"
      ></button>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-secondary"
        (click)="showDeleteModal = false"
        [disabled]="deleting"
        icon="pi pi-ban"
        [label]="'common.cancel' | translate | titlecase"
      ></button>
    </div>
  </ng-template>
</p-dialog>
